
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userHeight: initialUserSizing.height,
    userWeight: initialUserSizing.weight,
    userBootSize: initialUserSizing.bootSize,
    recommendedLength: initialUserSizing.boardSizes.length,
    minRecommendedLength: initialUserSizing.boardSizes.minLength,
    maxRecommendedLength: initialUserSizing.boardSizes.maxLength,
    minRecommendedWaist: initialUserSizing.boardSizes.minWaist,
    maxRecommendedWaist: initialUserSizing.boardSizes.maxWaist,
    idealRecommendedWaist: initialUserSizing.boardSizes.idealWaist,
    sizesChosen: false,
    terrain: initialUserSizing.terrain,
    beginner: initialUserSizing.beginner,
  },
  mutations: {
    setUserHeight (state, n) {
      state.userHeight = parseFloat(n);
    },
    setUserWeight (state, n) {
      state.userWeight = parseFloat(n);
    },
    setUserBootSize (state, n) {
      state.userBootSize = parseFloat(n);
    },
    setRecommendedLength (state, n) {
      state.recommendedLength = parseFloat(n);
    },
    setMinRecommendedLength (state, n) {
      state.minRecommendedLength = parseFloat(n);
    },
    setMinRecommendedWaist (state, n) {
      state.minRecommendedWaist = parseFloat(n);
    },
    setMaxRecommendedWaist (state, n) {
      state.maxRecommendedWaist = parseFloat(n);
    },
    setIdealRecommendedWaist (state, n) {
      state.idealRecommendedWaist = parseFloat(n);
    },
    setSizesChosen (state, n) {
      state.sizesChosen = n;
    },
    setTerrain (state, n) {
      state.terrain = n;
    },
    setBeginner (state, n) {
      state.beginner = n;
    },
  }
})
